const defaultTimeOptions = {
    default: {
        // 7:23 PM
        timeStyle: "short",
    },
};
export { defaultTimeOptions };
